import { Component, Host, Prop, h } from '@stencil/core';
import state from '@ugc-store';
import { stringFormat, handleErrorMessage, addDataLayer } from '@ugc-utils/utils';
import { Translate } from 'src/icons';
import { getReview } from '@ugc-api/review';
import { produce } from 'immer';

@Component({
  tag: 'ugc-review-switch-language',
  shadow: false,
})
export class UgcReviewSwitchLanguage {
  @Prop() reviewId: string;
  @Prop() translatedTo: string;
  @Prop() translatedToLanguageName: string;
  @Prop() languageCode: string;
  @Prop() languageName: string;

  getReviewDataById = async (reviewId, languageCode) => {
    try {
      const switchReviewItem = state.switchLanguage[this.reviewId];
      if (switchReviewItem && switchReviewItem.reviewText) {
        return switchReviewItem;
      }
      this.pushDataLayer(); //only trigger once for a review
      const data = (await getReview(reviewId, languageCode)) || {};
      return data;
    } catch (e) {
      handleErrorMessage(e);
      return {};
    }
  };

  pushDataLayer() {
    addDataLayer({ parameters: null });
    addDataLayer({
      event: 'translation_interaction',
      parameters: {
        interaction_type: 'show original language',
        current_language: this.translatedTo,
        original_language: this.languageCode,
      },
    });
  }

  handleSwitchLanguage = async () => {
    state.isShowSwitchLanguageModal = false;

    const data = await this.getReviewDataById(this.reviewId, this.languageCode);

    const switchLanguage = produce(state.switchLanguage, draft => {
      draft[this.reviewId] = {
        isShowOriginalLanguage: state.switchLanguage[this.reviewId]
          ? !state.switchLanguage[this.reviewId].isShowOriginalLanguage
          : true,
        reviewTitle: data.reviewTitle || '',
        reviewText: data.reviewText || '',
      };
    });
    state.switchLanguage = switchLanguage;
  };

  render() {
    if (!this.translatedTo || !this.languageName) return null;

    const {
      isDesktop,
      reviewStaticLanguage: { IDS_UGC_SHOW_ORIGINAL_LANGUAGE = '', IDS_UGC_SHOW_LANGUAGE = '' } = {},
      switchLanguage,
    } = state;

    const { isShowOriginalLanguage = false } = switchLanguage[this.reviewId] || {};
    const translateLabel = isShowOriginalLanguage
      ? stringFormat(IDS_UGC_SHOW_LANGUAGE, `${this.translatedToLanguageName}`)
      : IDS_UGC_SHOW_ORIGINAL_LANGUAGE;

    if (isDesktop)
      return (
        <Host class="mlr-4 fs-14 color-blue-dark pointer" onClick={this.handleSwitchLanguage}>
          {translateLabel}
        </Host>
      );

    return (
      <ugc-button type="text" customStyle={{ padding: '16px 0', fontWeight: 400 }}>
        <div class="flex-row-start-center" onClick={this.handleSwitchLanguage}>
          <Translate />
          <span class="mlr-8">{translateLabel}</span>
        </div>
      </ugc-button>
    );
  }
}
